export default [
  {
    label: 'No type',
    value: 'NO_TYPE'
  },
  {
    label: 'News',
    value: 'NEWS'
  },
  {
    label: 'Site news',
    value: 'SITE_NEWS'
  },
  {
    label: 'Offer',
    value: 'OFFER'
  },
  {
    label: 'Haul',
    value: 'HAUL'
  }
];
